<nav class="app-navrail" #nav aria-label="Site Navigation"></nav>
<div class="app-container">
  <header #header (hamburgerRequested)="toggleNav()" class="app-header"></header>
  <main class="main">
    <router-outlet (activate)="header.onActivate($event)" />
  </main>
</div>
